import React from 'react';
import PropTypes from 'prop-types';

export class CroppedImageView extends React.PureComponent {
  render() {
    const {
      originalWidth,
      resizeImageHeight,
      aspectRatio,
      src,
    } = this.props;

    const SourceWidth = this.props.SourceWidth || originalWidth;
    const SourceX = this.props.SourceX || 0;
    const SourceY = this.props.SourceY || 0;
    const borderRadius = this.props.borderRadius || 0;

    const resizeImageWidth = resizeImageHeight * aspectRatio;

    const imageToContainerRatio = resizeImageWidth / originalWidth;

    const cropSectionToImageRatio = originalWidth / SourceWidth;

    const negativeMarginX = -SourceX * imageToContainerRatio * cropSectionToImageRatio;
    const negativeMarginY = -SourceY * imageToContainerRatio * cropSectionToImageRatio;

    const resizeContainerStyle = {
      height: `${resizeImageHeight}px`,
      width: `${resizeImageWidth}px`,
      overflow: 'hidden',
      borderRadius: `${borderRadius}px`,
    };

    const resizeImageStyle = {
      width: `${resizeImageWidth * cropSectionToImageRatio}px`,
      marginLeft: `${negativeMarginX}px`,
      marginTop: `${negativeMarginY}px`,
    };

    return (
      <div
        className="cropped-image-view"
        style={resizeContainerStyle}
      >
        <img
          onContextMenu={e => e.preventDefault()}
          style={resizeImageStyle}
          src={src}
          alt={aspectRatio}
        />
      </div>
    );
  }
}

CroppedImageView.propTypes = {
  originalWidth: PropTypes.number.isRequired,
  resizeImageHeight: PropTypes.number.isRequired,
  aspectRatio: PropTypes.number.isRequired,
  SourceWidth: PropTypes.number,
  SourceX: PropTypes.number,
  SourceY: PropTypes.number,
  src: PropTypes.string.isRequired,
  borderRadius: PropTypes.number,
};

CroppedImageView.defaultProps = {
  SourceWidth: null,
  SourceX: null,
  SourceY: null,
  borderRadius: null,
};
